var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaginationDotActive = function SvgPaginationDotActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1476 8.62555C11.2566 8.68112 11.3904 8.63799 11.4419 8.52705C12.0048 7.31486 12.1477 5.94707 11.8441 4.64116C11.5237 3.26322 10.7267 2.0428 9.59389 1.19542C8.46105 0.348044 7.06522 -0.0717933 5.65289 0.0100486C4.24056 0.0918905 2.90257 0.670147 1.8752 1.64271C0.84782 2.61527 0.197139 3.91957 0.0380559 5.3253C-0.121028 6.73103 0.221719 8.14775 1.00577 9.32531C1.78982 10.5029 2.96475 11.3655 4.32307 11.7609C5.61039 12.1356 6.98396 12.0678 8.22516 11.5721C8.33875 11.5268 8.38916 11.3955 8.33963 11.2837C8.29011 11.1719 8.15943 11.1218 8.04571 11.1668C6.90012 11.6204 5.63391 11.6811 4.44687 11.3356C3.18882 10.9694 2.10063 10.1705 1.37446 9.07983C0.648288 7.9892 0.330844 6.67706 0.478183 5.37511C0.625523 4.07315 1.22817 2.86514 2.1797 1.96437C3.13124 1.06361 4.37045 0.528044 5.67852 0.452244C6.98659 0.376444 8.27937 0.765287 9.32858 1.55011C10.3778 2.33493 11.1159 3.46525 11.4127 4.74147C11.6927 5.94566 11.5627 7.20665 11.047 8.32566C10.9958 8.43675 11.0387 8.56997 11.1476 8.62555Z",
    fill: "url(#paint0_linear_6_3155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6ZM2.89655 6C2.89655 7.71399 4.28601 9.10345 6 9.10345C7.71399 9.10345 9.10345 7.71399 9.10345 6C9.10345 4.28601 7.71399 2.89655 6 2.89655C4.28601 2.89655 2.89655 4.28601 2.89655 6Z",
    fill: "url(#paint1_linear_6_3155)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52512 5.21214C1.27693 5.16844 1.03811 5.33426 1.01721 5.5854C0.932698 6.60088 1.16037 7.62207 1.67547 8.50968C2.26721 9.52933 3.20022 10.3071 4.30973 10.7056C5.41924 11.1042 6.63388 11.0978 7.73918 10.6878C8.84448 10.2777 9.76934 9.49027 10.3504 8.46451C10.9315 7.43875 11.1315 6.24065 10.915 5.08179C10.6985 3.92292 10.0794 2.87782 9.16721 2.13105C8.25498 1.38427 7.10821 0.983854 5.92941 1.0005C4.90327 1.01499 3.91031 1.3447 3.08275 1.93924C2.87809 2.08628 2.85863 2.37637 3.02371 2.56679C3.18878 2.7572 3.47571 2.77534 3.68332 2.6325C4.34588 2.17668 5.13141 1.92444 5.94229 1.91299C6.90594 1.89938 7.84341 2.22672 8.58914 2.8372C9.33488 3.44767 9.84092 4.30202 10.0179 5.24938C10.1949 6.19673 10.0314 7.17615 9.5564 8.01469C9.08137 8.85323 8.32532 9.49695 7.42175 9.83218C6.51819 10.1674 5.52523 10.1726 4.61823 9.84678C3.71122 9.52098 2.94851 8.88517 2.46477 8.05162C2.05772 7.35021 1.87024 6.54676 1.92059 5.74413C1.93637 5.49262 1.7733 5.25583 1.52512 5.21214Z",
    fill: "url(#paint2_linear_6_3155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_3155",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_3155",
    x1: 6,
    y1: 2.5,
    x2: 6,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_3155",
    x1: 6,
    y1: 1,
    x2: 6,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC7722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F3E47"
  })))));
};
export default SvgPaginationDotActive;